module.exports = __webpack_public_path__ + "img/impactoI4.47ddc556.png";